import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Box, Toolbar, Typography, Container, Button } from "@mui/material";
import Navbar from "./components/Navbar";
import LogInPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import ContractsPage from "./pages/ContractsPage";
import MyDataPage from "./pages/MyDataPage";
import MQL4Page from "./pages/MQL4Page";
import MQL4ProfitsPage from "./pages/MQL4ProfitsPage";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import api from "./components/api/api";

function App() {
  const [pinVerified, setPinVerified] = useState(false);
  const [pinChecked, setPinChecked] = useState(false);
  const [user, setUser] = useState(null);
  const [mobile, setMobile] = useState(0);
  const [accountsCount, setAccountsCount] = useState(0);
  const [totalProfit, setTotalProfit] = useState(null);
  const [totalBalance, setTotalBalance] = useState(null);
  const [mql4Protocol, setMql4Protocol] = useState(null);
  const [requestedProfits, setRequestedProfits] = useState(false);

  const [excess, setExcess] = useState(0);

  const askForPin = React.useCallback(() => {
    const attempt = window.prompt("Ingresa el PIN para acceder:");
    if (attempt === "552255") {
      sessionStorage.setItem("taurus_pin_ok", "true");
      setPinVerified(true);
      setPinChecked(true);
    } else if (attempt === null) {
      setPinChecked(true);
    } else {
      alert("PIN incorrecto. Intentalo de nuevo.");
      askForPin();
    }
  }, []);

  React.useEffect(() => {
    const storedPin = sessionStorage.getItem("taurus_pin_ok");
    if (storedPin === "true") {
      setPinVerified(true);
      setPinChecked(true);
      return;
    }

    askForPin();
  }, [askForPin]);

  useEffect(() => {
    if (mql4Protocol) {
      //updateMql4Protocol();
    }
  }, [mql4Protocol]);

  const updateMql4Protocol = () => {
    api.updateMQL4Protocol(
      mql4Protocol,
      () => {},
      () => {}
    );
  };

  const handleResize = () => {
    if (isMobile && window.screen.orientation.type.includes("portrait")) {
      setMobile(1);
    } else if (window.innerWidth < 600) {
      setMobile(1);
    } else if (isMobile) {
      setMobile(2);
    } else {
      setMobile(0);
    }
  };

  const calculateNavBarHeight = () => {
    if (window.innerWidth < 600) return 56;
    return 64;
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem("taurus_user"));
    if (user) {
      setUser(user);
    } else {
      setUser(null);
    }
  }, []);

  const handleLogOut = () => {
    localStorage.setItem("taurus_user", null);
    setUser(null);
    setAccountsCount(0);
  };

  const handleLogIn = (user) => {
    console.log(user);
    localStorage.setItem("taurus_user", JSON.stringify(user));
    setUser(user);
  };

  const handleAuthError = () => {
    handleLogOut();
  };

  if (!pinVerified && !pinChecked) {
    return null;
  }

  if (!pinVerified && pinChecked) {
    return (
      <Box
        style={{
          background: "#0A0A0A",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#ffffff",
          padding: 24,
        }}
      >
        <Typography variant="h6" style={{ marginBottom: 16, textAlign: "center" }}>
          Ingresa el PIN para acceder.
        </Typography>
        <Button variant="contained" onClick={askForPin}>
          Ingresar PIN
        </Button>
      </Box>
    );
  }

  return (
    <>
      <Router>
        <Box
          style={{
            background: "#0A0A0A",
          }}
        >
          <Navbar
            {...{
              loggedIn: user,
              logOut: handleLogOut,
              accountsCount: accountsCount,
              totalProfit: totalProfit,
              totalBalance: totalBalance,
              setMql4Protocol: setMql4Protocol,
              mql4Protocol: mql4Protocol,
              excess: excess,
            }}
          />

          <Box
            style={{
              background: "#0A0A0A",
              //background: "#ffffff",
              display: "flex",
              width: "100%",
              marginTop: calculateNavBarHeight(),
              minHeight: !mobile ? `calc(100vh - ${calculateNavBarHeight()}px)` : undefined,
            }}
          >
            <Routes>
              <Route
                path="/"
                element={
                  <MQL4Page
                    setAccountsCount={(count) => setAccountsCount(count)}
                    setTotalProfit={setTotalProfit}
                    mql4Protocol={mql4Protocol}
                    setMql4Protocol={(protocol) => setMql4Protocol(protocol)}
                    setExcess={(exs) => setExcess(exs)}
                    setTotalBalance={setTotalBalance}
                  />
                }
              />
              <Route
                path="/contratos"
                element={!user ? <Navigate to="/" /> : <ContractsPage {...{ user, handleAuthError }} />}
              />
              <Route
                path="/misdatos"
                element={!user ? <Navigate to="/" /> : <MyDataPage {...{ user, handleAuthError }} />}
              />
              <Route
                path="/loginprofits"
                element={!user ? <LogInPage loginSucceed={handleLogIn} /> : <Navigate to="/" />}
              />
              <Route
                path="/profits"
                element={
                  !user ? (
                    <Navigate to="/loginprofits" />
                  ) : (
                    <MQL4ProfitsPage
                      setAccountsCount={(count) => setAccountsCount(count)}
                      setTotalProfit={setTotalProfit}
                      setTotalBalance={setTotalBalance}
                    />
                  )
                }
              />
              <Route
                path="/mql4"
                element={
                  <MQL4Page
                    setAccountsCount={(count) => setAccountsCount(count)}
                    setTotalProfit={setTotalProfit}
                    mql4Protocol={mql4Protocol}
                    setMql4Protocol={(protocol) => setMql4Protocol(protocol)}
                    setTotalBalance={setTotalBalance}
                  />
                }
              />
            </Routes>
          </Box>
        </Box>
      </Router>
    </>
  );
}

export default App;
